import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _424af331 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _1a10360b = () => interopDefault(import('../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _7a2fef42 = () => interopDefault(import('../pages/art/index.vue' /* webpackChunkName: "pages/art/index" */))
const _44d0b782 = () => interopDefault(import('../pages/available.vue' /* webpackChunkName: "pages/available" */))
const _5cdcabda = () => interopDefault(import('../pages/donations.vue' /* webpackChunkName: "pages/donations" */))
const _3bf9d973 = () => interopDefault(import('../pages/index_old.vue' /* webpackChunkName: "pages/index_old" */))
const _66e430e7 = () => interopDefault(import('../pages/jspreadsheet-demo.vue' /* webpackChunkName: "pages/jspreadsheet-demo" */))
const _9b53a324 = () => interopDefault(import('../pages/maps.vue' /* webpackChunkName: "pages/maps" */))
const _1b608300 = () => interopDefault(import('../pages/ms/index.vue' /* webpackChunkName: "pages/ms/index" */))
const _6facc6c3 = () => interopDefault(import('../pages/my.vue' /* webpackChunkName: "pages/my" */))
const _30c5a54e = () => interopDefault(import('../pages/my-art.vue' /* webpackChunkName: "pages/my-art" */))
const _1f437597 = () => interopDefault(import('../pages/mystat.vue' /* webpackChunkName: "pages/mystat" */))
const _362f3150 = () => interopDefault(import('../pages/objects/index.vue' /* webpackChunkName: "pages/objects/index" */))
const _76e67aa2 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _22e443d6 = () => interopDefault(import('../pages/same_objects/index.vue' /* webpackChunkName: "pages/same_objects/index" */))
const _e27b2d82 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _7f1c351f = () => interopDefault(import('../pages/search-pro.vue' /* webpackChunkName: "pages/search-pro" */))
const _61cb8677 = () => interopDefault(import('../pages/sp/index.vue' /* webpackChunkName: "pages/sp/index" */))
const _01f8308c = () => interopDefault(import('../pages/statistics.vue' /* webpackChunkName: "pages/statistics" */))
const _222ed431 = () => interopDefault(import('../pages/u/index.vue' /* webpackChunkName: "pages/u/index" */))
const _69c3cb5c = () => interopDefault(import('../pages/admin/art.vue' /* webpackChunkName: "pages/admin/art" */))
const _73095cdf = () => interopDefault(import('../pages/admin/art/index.vue' /* webpackChunkName: "pages/admin/art/index" */))
const _21e72001 = () => interopDefault(import('../pages/admin/backgrounds/index.vue' /* webpackChunkName: "pages/admin/backgrounds/index" */))
const _544293b3 = () => interopDefault(import('../pages/admin/categories.vue' /* webpackChunkName: "pages/admin/categories" */))
const _40df7014 = () => interopDefault(import('../pages/admin/categories/index.vue' /* webpackChunkName: "pages/admin/categories/index" */))
const _175bcfde = () => interopDefault(import('../pages/admin/categories/_id.vue' /* webpackChunkName: "pages/admin/categories/_id" */))
const _242fb34b = () => interopDefault(import('../pages/admin/comments.vue' /* webpackChunkName: "pages/admin/comments" */))
const _d8c554e4 = () => interopDefault(import('../pages/admin/comments/index.vue' /* webpackChunkName: "pages/admin/comments/index" */))
const _2ed6d714 = () => interopDefault(import('../pages/admin/donats.vue' /* webpackChunkName: "pages/admin/donats" */))
const _703a82d2 = () => interopDefault(import('../pages/admin/donats/index.vue' /* webpackChunkName: "pages/admin/donats/index" */))
const _3d6d7abf = () => interopDefault(import('../pages/admin/donats/_id.vue' /* webpackChunkName: "pages/admin/donats/_id" */))
const _0f46075a = () => interopDefault(import('../pages/admin/icons.vue' /* webpackChunkName: "pages/admin/icons" */))
const _2021b896 = () => interopDefault(import('../pages/admin/icons/index.vue' /* webpackChunkName: "pages/admin/icons/index" */))
const _3e5e2f04 = () => interopDefault(import('../pages/admin/icons/_id.vue' /* webpackChunkName: "pages/admin/icons/_id" */))
const _7aa67d0d = () => interopDefault(import('../pages/admin/objects.vue' /* webpackChunkName: "pages/admin/objects" */))
const _d6db7460 = () => interopDefault(import('../pages/admin/objects/index.vue' /* webpackChunkName: "pages/admin/objects/index" */))
const _0cf32266 = () => interopDefault(import('../pages/admin/property_templates.vue' /* webpackChunkName: "pages/admin/property_templates" */))
const _0619c469 = () => interopDefault(import('../pages/admin/property_templates/index.vue' /* webpackChunkName: "pages/admin/property_templates/index" */))
const _5a2065de = () => interopDefault(import('../pages/admin/property_templates/_id.vue' /* webpackChunkName: "pages/admin/property_templates/_id" */))
const _74df4892 = () => interopDefault(import('../pages/admin/same_objects.vue' /* webpackChunkName: "pages/admin/same_objects" */))
const _11639995 = () => interopDefault(import('../pages/admin/same_objects/index.vue' /* webpackChunkName: "pages/admin/same_objects/index" */))
const _1391e1fa = () => interopDefault(import('../pages/admin/settings.vue' /* webpackChunkName: "pages/admin/settings" */))
const _6a323a32 = () => interopDefault(import('../pages/admin/types.vue' /* webpackChunkName: "pages/admin/types" */))
const _0ee2d335 = () => interopDefault(import('../pages/admin/types/index.vue' /* webpackChunkName: "pages/admin/types/index" */))
const _6ff3c246 = () => interopDefault(import('../pages/admin/types/_id.vue' /* webpackChunkName: "pages/admin/types/_id" */))
const _5f7a1041 = () => interopDefault(import('../pages/admin/users.vue' /* webpackChunkName: "pages/admin/users" */))
const _41efa204 = () => interopDefault(import('../pages/admin/users/index.vue' /* webpackChunkName: "pages/admin/users/index" */))
const _eb735528 = () => interopDefault(import('../pages/admin/users/_id.vue' /* webpackChunkName: "pages/admin/users/_id" */))
const _7c656382 = () => interopDefault(import('../pages/art/create.vue' /* webpackChunkName: "pages/art/create" */))
const _16a25d25 = () => interopDefault(import('../pages/auth/force-oauth.vue' /* webpackChunkName: "pages/auth/force-oauth" */))
const _3cab5e6b = () => interopDefault(import('../pages/ms/assistant_ai.vue' /* webpackChunkName: "pages/ms/assistant_ai" */))
const _eb97aea4 = () => interopDefault(import('../pages/ms/assistant_ai/index.vue' /* webpackChunkName: "pages/ms/assistant_ai/index" */))
const _9293cda2 = () => interopDefault(import('../pages/ms/assistant_ai/dialogue/index.vue' /* webpackChunkName: "pages/ms/assistant_ai/dialogue/index" */))
const _62d55a78 = () => interopDefault(import('../pages/ms/assistant_ai/dialogue_list/index.vue' /* webpackChunkName: "pages/ms/assistant_ai/dialogue_list/index" */))
const _143a155e = () => interopDefault(import('../pages/ms/assistant_ai/projects/index.vue' /* webpackChunkName: "pages/ms/assistant_ai/projects/index" */))
const _a4bfd00e = () => interopDefault(import('../pages/ms/assistant_ai/projects/_id.vue' /* webpackChunkName: "pages/ms/assistant_ai/projects/_id" */))
const _725ee3c6 = () => interopDefault(import('../pages/ms/scan_social.vue' /* webpackChunkName: "pages/ms/scan_social" */))
const _318f4ae0 = () => interopDefault(import('../pages/ms/scan_social/index.vue' /* webpackChunkName: "pages/ms/scan_social/index" */))
const _37ca949e = () => interopDefault(import('../pages/ms/scan_social/messages/index.vue' /* webpackChunkName: "pages/ms/scan_social/messages/index" */))
const _a53c9f80 = () => interopDefault(import('../pages/ms/scan_social/source/index.vue' /* webpackChunkName: "pages/ms/scan_social/source/index" */))
const _ebc27ab0 = () => interopDefault(import('../pages/ms/scan_social/source/_id.vue' /* webpackChunkName: "pages/ms/scan_social/source/_id" */))
const _91297924 = () => interopDefault(import('../pages/objects/create.vue' /* webpackChunkName: "pages/objects/create" */))
const _0ae22f49 = () => interopDefault(import('../pages/same_objects/create.vue' /* webpackChunkName: "pages/same_objects/create" */))
const _014cd9b2 = () => interopDefault(import('../pages/sp/create.vue' /* webpackChunkName: "pages/sp/create" */))
const _0de1a2ae = () => interopDefault(import('../pages/admin/backgrounds/_id.vue' /* webpackChunkName: "pages/admin/backgrounds/_id" */))
const _6277ff4c = () => interopDefault(import('../pages/art/_slug/index.vue' /* webpackChunkName: "pages/art/_slug/index" */))
const _36caf08b = () => interopDefault(import('../pages/objects/_slug/index.vue' /* webpackChunkName: "pages/objects/_slug/index" */))
const _12a26532 = () => interopDefault(import('../pages/s/_slug.vue' /* webpackChunkName: "pages/s/_slug" */))
const _15a43590 = () => interopDefault(import('../pages/same_objects/_slug/index.vue' /* webpackChunkName: "pages/same_objects/_slug/index" */))
const _83b2e71c = () => interopDefault(import('../pages/sp/_slug/index.vue' /* webpackChunkName: "pages/sp/_slug/index" */))
const _5f162ed9 = () => interopDefault(import('../pages/u/_id.vue' /* webpackChunkName: "pages/u/_id" */))
const _1f5cec94 = () => interopDefault(import('../pages/objects/_slug/infographic/index.vue' /* webpackChunkName: "pages/objects/_slug/infographic/index" */))
const _6b42d9a1 = () => interopDefault(import('../pages/objects/_slug/infographic/_id/index.vue' /* webpackChunkName: "pages/objects/_slug/infographic/_id/index" */))
const _0157118b = () => interopDefault(import('../pages/objects/_slug/infographic/_id/edit.vue' /* webpackChunkName: "pages/objects/_slug/infographic/_id/edit" */))
const _01debcea = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _424af331,
    meta: {"layout":"public_new","props":["error"]},
    name: "404"
  }, {
    path: "/admin",
    component: _1a10360b,
    meta: {"name":"AdminHome","layout":"admin","middleware":"custom-auth","title":"Vistat","permission":["A","CA"]},
    name: "admin"
  }, {
    path: "/art",
    component: _7a2fef42,
    meta: {"name":"ArtList","layout":"public_new"},
    name: "art"
  }, {
    path: "/available",
    component: _44d0b782,
    meta: {"name":"MyObjects","layout":"public_new","middleware":"custom-auth"},
    name: "available"
  }, {
    path: "/donations",
    component: _5cdcabda,
    meta: {"name":"Donations","layout":"public_new"},
    name: "donations"
  }, {
    path: "/index_old",
    component: _3bf9d973,
    meta: {"name":"ObjectsList","layout":"public_new"},
    name: "index_old"
  }, {
    path: "/jspreadsheet-demo",
    component: _66e430e7,
    meta: {"name":"TableDemo"},
    name: "jspreadsheet-demo"
  }, {
    path: "/maps",
    component: _9b53a324,
    meta: {"name":"MapsCreate","layout":"public_new","middleware":"custom-auth"},
    name: "maps"
  }, {
    path: "/ms",
    component: _1b608300,
    meta: {"name":"MicroServiceHome","layout":"microservice","title":"MicroServices Vistat"},
    name: "ms"
  }, {
    path: "/my",
    component: _6facc6c3,
    meta: {"name":"MyObjects","layout":"public_new","middleware":"custom-auth"},
    name: "my"
  }, {
    path: "/my-art",
    component: _30c5a54e,
    meta: {"name":"MyArtList","layout":"public_new","middleware":"custom-auth"},
    name: "my-art"
  }, {
    path: "/mystat",
    component: _1f437597,
    meta: {"name":"MyStat","layout":"public_new","middleware":"custom-auth"},
    name: "mystat"
  }, {
    path: "/objects",
    component: _362f3150,
    meta: {"name":"Objects","layout":"public_new"},
    name: "objects"
  }, {
    path: "/profile",
    component: _76e67aa2,
    meta: {"name":"Profile","layout":"public_new","middleware":"custom-auth"},
    name: "profile"
  }, {
    path: "/same_objects",
    component: _22e443d6,
    meta: {"name":"SameObjectsList","layout":"public_new"},
    name: "same_objects"
  }, {
    path: "/search",
    component: _e27b2d82,
    meta: {"name":"Search","layout":"public_new"},
    name: "search"
  }, {
    path: "/search-pro",
    component: _7f1c351f,
    meta: {"name":"SearchPro","layout":"public_new"},
    name: "search-pro"
  }, {
    path: "/sp",
    component: _61cb8677,
    meta: {"name":"ArtSpList","layout":"public_new"},
    name: "sp"
  }, {
    path: "/statistics",
    component: _01f8308c,
    meta: {"name":"Statistics","layout":"public_new","middleware":"custom-auth"},
    name: "statistics"
  }, {
    path: "/u",
    component: _222ed431,
    meta: {"name":"UsersPublicList","layout":"public_new"},
    name: "u"
  }, {
    path: "/admin/art",
    component: _69c3cb5c,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Список статей","name":"admin-art","permission":["A","CA","CE"]},
    children: [{
      path: "",
      component: _73095cdf,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список статей","name":"admin-art-list","permission":["A","CA","CE"]},
      name: "admin-art"
    }]
  }, {
    path: "/admin/backgrounds",
    component: _21e72001,
    meta: {"name":"admin-backgrounds-list","layout":"admin","middleware":"custom-auth","title":"Коллекция фонов","permission":["A","CA"]},
    name: "admin-backgrounds"
  }, {
    path: "/admin/categories",
    component: _544293b3,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Категории","name":"admin-categories","permission":["A"]},
    children: [{
      path: "",
      component: _40df7014,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список категорий","name":"admin-categories-list","permission":["A"]},
      name: "admin-categories"
    }, {
      path: ":id",
      component: _175bcfde,
      meta: {"name":"AdminCategoriesId","layout":"admin","middleware":"custom-auth","title":"Редактирование категории","permission":["A"]},
      name: "admin-categories-id"
    }]
  }, {
    path: "/admin/comments",
    component: _242fb34b,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Список комментариев","name":"admin-comments","permission":["A","CA"]},
    children: [{
      path: "",
      component: _d8c554e4,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список комментариев","name":"admin-comments-list","permission":["A","CA"]},
      name: "admin-comments"
    }]
  }, {
    path: "/admin/donats",
    component: _2ed6d714,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Благотворитель","name":"admin-donats","permission":["A"]},
    children: [{
      path: "",
      component: _703a82d2,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список Благотворителей","name":"admin-donats-list","permission":["A"]},
      name: "admin-donats"
    }, {
      path: ":id",
      component: _3d6d7abf,
      meta: {"name":"AdminDonatsId","layout":"admin","middleware":"custom-auth","title":"Редактирование Благотворителя","permission":["A"]},
      name: "admin-donats-id"
    }]
  }, {
    path: "/admin/icons",
    component: _0f46075a,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Коллекция иконок","name":"admin-icons","permission":["A","CA"]},
    children: [{
      path: "",
      component: _2021b896,
      meta: {"name":"admin-icons-list","layout":"admin","middleware":"custom-auth","title":"Коллекция иконок","permission":["A","CA"]},
      name: "admin-icons"
    }, {
      path: ":id",
      component: _3e5e2f04,
      meta: {"name":"AdminIconsId","layout":"admin","middleware":"custom-auth","title":"Редактирование иконки","permission":["A","CA"]},
      name: "admin-icons-id"
    }]
  }, {
    path: "/admin/objects",
    component: _7aa67d0d,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Список объектов","name":"admin-objects","permission":["A","CA","CE"]},
    children: [{
      path: "",
      component: _d6db7460,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список объектов","name":"admin-objects-list","permission":["A","CA","CE"]},
      name: "admin-objects"
    }]
  }, {
    path: "/admin/property_templates",
    component: _0cf32266,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Список шаблонов","name":"admin-property_templates","permission":["A","CA"]},
    children: [{
      path: "",
      component: _0619c469,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список шаблонов","name":"admin-property_templates-list","permission":["A","CA"]},
      name: "admin-property_templates"
    }, {
      path: ":id",
      component: _5a2065de,
      meta: {"name":"AdminPropertyTemplatesId","layout":"admin","middleware":"custom-auth","title":"Редактирование шаблона","permission":["A","CA"]},
      name: "admin-property_templates-id"
    }]
  }, {
    path: "/admin/same_objects",
    component: _74df4892,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Список модульных объектов","name":"admin-same_objects","permission":["A","CA","CE"]},
    children: [{
      path: "",
      component: _11639995,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список модульных объектов","name":"admin-same_objects-list","permission":["A","CA","CE"]},
      name: "admin-same_objects"
    }]
  }, {
    path: "/admin/settings",
    component: _1391e1fa,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Общие настройки","name":"admin-settings","permission":["A"]},
    name: "admin-settings"
  }, {
    path: "/admin/types",
    component: _6a323a32,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Список типов","name":"admin-types","permission":["A","CA"]},
    children: [{
      path: "",
      component: _0ee2d335,
      meta: {"layout":"admin","middleware":"custom-auth","title":"Список типов","name":"admin-types-list","permission":["A","CA"]},
      name: "admin-types"
    }, {
      path: ":id",
      component: _6ff3c246,
      meta: {"name":"AdminTypesId","layout":"admin","middleware":"custom-auth","title":"Редактирование типа объекта","permission":["A","CA"]},
      name: "admin-types-id"
    }]
  }, {
    path: "/admin/users",
    component: _5f7a1041,
    meta: {"layout":"admin","middleware":"custom-auth","title":"Пользователи","name":"admin-users","permission":["A"]},
    children: [{
      path: "",
      component: _41efa204,
      meta: {"layout":"AdminUsers","middleware":"custom-auth","title":"Список пользователей","name":"admin-users-list","permission":["A"]},
      name: "admin-users"
    }, {
      path: ":id",
      component: _eb735528,
      meta: {"name":"admin-users-id","layout":"admin","middleware":"custom-auth","title":"Редактирование пользователя","permission":["A"]},
      name: "admin-users-id"
    }]
  }, {
    path: "/art/create",
    component: _7c656382,
    meta: {"name":"Create","layout":"public_new","middleware":"custom-auth"},
    name: "art-create"
  }, {
    path: "/auth/force-oauth",
    component: _16a25d25,
    meta: {"name":"auth-force-oauth","layout":"public_new","middleware":"custom-auth","title":"Обновление способа входа"},
    name: "auth-force-oauth"
  }, {
    path: "/ms/assistant_ai",
    component: _3cab5e6b,
    meta: {"name":"ms-assistant_ai","title":"Assistant AI"},
    children: [{
      path: "",
      component: _eb97aea4,
      meta: {"name":"ms-assistant_ai-list","layout":"microservice","title":"Assistant AI"},
      name: "ms-assistant_ai"
    }, {
      path: "dialogue",
      component: _9293cda2,
      meta: {"name":"MsAssistantAiDialogueListPage"},
      name: "ms-assistant_ai-dialogue"
    }, {
      path: "dialogue_list",
      component: _62d55a78,
      meta: {"name":"ms-assistant_ai-dialogue_list","layout":"microservice","title":"Список диалогов","permission":["A","CA"]},
      name: "ms-assistant_ai-dialogue_list"
    }, {
      path: "projects",
      component: _143a155e,
      meta: {"name":"ms-assistant_ai-projects","layout":"microservice","title":"Проекты","permission":["A","CA"]},
      name: "ms-assistant_ai-projects"
    }, {
      path: "projects/:id",
      component: _a4bfd00e,
      meta: {"name":"ms-assistant_ai-projects-id","layout":"microservice","title":"Проект","permission":["A","CA"]},
      name: "ms-assistant_ai-projects-id"
    }]
  }, {
    path: "/ms/scan_social",
    component: _725ee3c6,
    meta: {"name":"ms-scan_social","layout":"microservice","title":"Парсер"},
    children: [{
      path: "",
      component: _318f4ae0,
      meta: {"name":"ms-scan_social-list","layout":"microservice","title":"Парсер источников и сообщений","permission":["A","CA"]},
      name: "ms-scan_social"
    }, {
      path: "messages",
      component: _37ca949e,
      meta: {"layout":"microservice","title":"Список Сообщений","name":"ms-scan_social-messages"},
      name: "ms-scan_social-messages"
    }, {
      path: "source",
      component: _a53c9f80,
      meta: {"layout":"microservice","title":"Список Источников","name":"ms-scan_social-source"},
      name: "ms-scan_social-source"
    }, {
      path: "source/:id",
      component: _ebc27ab0,
      meta: {"name":"MsScanSocialSourceId","layout":"microservice","title":"Источник"},
      name: "ms-scan_social-source-id"
    }]
  }, {
    path: "/objects/create",
    component: _91297924,
    meta: {"name":"AdminObjectsId","layout":"public_new","middleware":"custom-auth","title":"Редактирование объекта"},
    name: "objects-create"
  }, {
    path: "/same_objects/create",
    component: _0ae22f49,
    meta: {"name":"CreateSameObjects","layout":"public_new","middleware":"custom-auth"},
    name: "same_objects-create"
  }, {
    path: "/sp/create",
    component: _014cd9b2,
    meta: {"name":"CreateSp","layout":"public_new","middleware":"custom-auth"},
    name: "sp-create"
  }, {
    path: "/admin/backgrounds/:id",
    component: _0de1a2ae,
    meta: {"name":"AdminBackgroundsId","layout":"admin","middleware":"custom-auth","title":"Редактирование фона","permission":["A","CA"]},
    name: "admin-backgrounds-id"
  }, {
    path: "/art/:slug",
    component: _6277ff4c,
    meta: {"name":"ArtDetail","layout":"public_new","pageLayoutBg":"#ffffff"},
    name: "art-slug"
  }, {
    path: "/objects/:slug",
    component: _36caf08b,
    meta: {"name":"ObjectView","layout":"public_new","pageLayoutBg":"#ffffff"},
    name: "objects-slug"
  }, {
    path: "/s/:slug?",
    component: _12a26532,
    meta: {"name":"ObjectsList","layout":"public_new"},
    name: "s-slug"
  }, {
    path: "/same_objects/:slug",
    component: _15a43590,
    meta: {"name":"SameObjectView","layout":"public_new"},
    name: "same_objects-slug"
  }, {
    path: "/sp/:slug",
    component: _83b2e71c,
    meta: {"name":"ArtSpDetail","layout":"art_special_project"},
    name: "sp-slug"
  }, {
    path: "/u/:id",
    component: _5f162ed9,
    meta: {"name":"UserPublicProfile","layout":"public_new"},
    name: "u-id"
  }, {
    path: "/objects/:slug/infographic",
    component: _1f5cec94,
    meta: {"name":"InfographicList","layout":"public_new","middleware":"custom-auth"},
    name: "objects-slug-infographic"
  }, {
    path: "/objects/:slug/infographic/:id",
    component: _6b42d9a1,
    meta: {"name":"InfographicView","layout":"public_new","middleware":"custom-auth","title":"Инфографика","permission":["A","CA","SCE","IG"]},
    name: "objects-slug-infographic-id"
  }, {
    path: "/objects/:slug/infographic/:id/edit",
    component: _0157118b,
    meta: {"name":"InfographicPageEditor","layout":"public_new","middleware":"custom-auth","title":"Инфографика","permission":["A","CA","SCE","IG"]},
    name: "objects-slug-infographic-id-edit"
  }, {
    path: "/",
    component: _01debcea,
    meta: {"name":"ObjectsList","layout":"public_new"},
    name: "index"
  }, {
    path: "/objects/:slug/edit",
    component: _91297924,
    meta: {"name":"AdminObjectsId","layout":"public_new","middleware":"custom-auth","title":"Редактирование объекта"},
    name: "objects_edit"
  }, {
    path: "/objects/:slug/new-infographic",
    component: _0157118b,
    meta: {"name":"InfographicPageEditor","layout":"public_new","middleware":"custom-auth","title":"Инфографика","permission":["A","CA","SCE","IG"]},
    name: "new_infographic"
  }, {
    path: "/art/:id/edit",
    component: _7c656382,
    meta: {"name":"Create","layout":"public_new","middleware":"custom-auth"},
    name: "art_edit"
  }, {
    path: "/sp/:id/edit",
    component: _014cd9b2,
    meta: {"name":"CreateSp","layout":"public_new","middleware":"custom-auth"},
    name: "sp_edit"
  }, {
    path: "/same_objects/:slug/edit",
    component: _0ae22f49,
    meta: {"name":"CreateSameObjects","layout":"public_new","middleware":"custom-auth"},
    name: "same_objects_edit"
  }, {
    path: "*",
    component: _424af331,
    meta: {"layout":"public_new","props":["error"]},
    name: "not-found"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
